import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss']
})
export class StepperComponent implements OnInit {
  
  @Input() stepperInfo:{stepNumber:number,stepText:string}[];
  @Input() displayStep: number;

  constructor() {
  }

  ngOnInit(): void {
  }

}
